import { render, staticRenderFns } from "./categoryTableGeo.vue?vue&type=template&id=5ad009a0&scoped=true"
import script from "./categoryTableGeo.vue?vue&type=script&lang=js"
export * from "./categoryTableGeo.vue?vue&type=script&lang=js"
import style0 from "./categoryTableGeo.vue?vue&type=style&index=0&id=5ad009a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad009a0",
  null
  
)

export default component.exports